function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.83333 10.2034C3.83264 8.61043 4.32813 7.05683 5.25097 5.75845C6.17381 4.46007 7.47815 3.48137 8.98278 2.95836C8.92451 2.59331 8.94614 2.21997 9.04616 1.86409C9.14618 1.50821 9.32222 1.17826 9.56213 0.897021C9.80205 0.615778 10.1001 0.389932 10.4358 0.235066C10.7715 0.0801999 11.1367 0 11.5064 0C11.8761 0 12.2413 0.0801999 12.577 0.235066C12.9127 0.389932 13.2107 0.615778 13.4506 0.897021C13.6906 1.17826 13.8666 1.50821 13.9666 1.86409C14.0666 2.21997 14.0883 2.59331 14.03 2.95836C15.5322 3.48352 16.8338 4.46313 17.7542 5.76133C18.6747 7.05953 19.1683 8.61198 19.1667 10.2034V17.87L23 20.4256V21.7034H0V20.4256L3.83333 17.87V10.2034ZM14.0556 22.9811C14.0556 23.6589 13.7863 24.3089 13.3071 24.7882C12.8278 25.2674 12.1778 25.5367 11.5 25.5367C10.8222 25.5367 10.1722 25.2674 9.69295 24.7882C9.21369 24.3089 8.94444 23.6589 8.94444 22.9811H14.0556Z",
  fill: "#EFEFEF"
});

var SvgNotificationIcon = function SvgNotificationIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNotificationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification-icon.d8d0bdb4.svg";
export { ForwardRef as ReactComponent };